import axios from "axios";
import { API } from "@/lib/api";

// Auth uses an httpOnly cookie set by the backend (same-origin). No tokens in JS storage.
const cfg = { withCredentials: true };

export const ADMIN_AUTH_EVENT = "admin-auth-changed";
const announce = () => window.dispatchEvent(new Event(ADMIN_AUTH_EVENT));

export async function adminLogin(email, password) {
  const { data } = await axios.post(`${API}/auth/login`, { email, password }, cfg);
  announce();
  return data;
}

export async function adminLogout() {
  try {
    await axios.post(`${API}/auth/logout`, {}, cfg);
  } catch (e) {
    if (process.env.NODE_ENV !== "production") {
      console.error("Logout request failed:", e);
    }
  }
  announce();
}

export async function fetchMe() {
  const { data } = await axios.get(`${API}/auth/me`, cfg);
  return data;
}

export async function fetchNotify() {
  const { data } = await axios.get(`${API}/admin/notify`, cfg);
  return data;
}

export async function fetchSales() {
  const { data } = await axios.get(`${API}/admin/sales`, cfg);
  return data;
}

export async function fetchFreeDownloads() {
  const { data } = await axios.get(`${API}/admin/free-downloads`, cfg);
  return data;
}

export async function fetchReport() {
  const { data } = await axios.get(`${API}/admin/report`, cfg);
  return data;
}

export async function exportReport(report, filename) {
  const res = await axios.get(`${API}/admin/export/${report}`, {
    ...cfg,
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
